import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import AwesomeError from 'components/Common/AwesomeError'
import BodyText from 'LuxKit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'

/** @deprecated */
function CalendarRecommendationsNotAvailableMessage() {
  const intl = useIntl()
  const contact = useContext(ContactContext)
  return (
    <AwesomeError title={intl.formatMessage({
      id: 'qxs4IdT0V0',
      defaultMessage: 'No offers found for the dates you requested.',
      description: 'Error title when no calendar recommendations are found',
    })}
    >
      {/* TODO: i18n - body text contains <br /> tag */}
      <BodyText variant="large" colour="neutral-one">
        But we probably have something for you.<br />
        <a
          href={`tel:${contact.defaultContact.number}`}
          rel="nofollow"
        >{contact.defaultContact.humanReadable}
        </a>.
      </BodyText>
    </AwesomeError>
  )
}

export default CalendarRecommendationsNotAvailableMessage
